<template>
  <div class="user-center">
    <div class="container">
      <section class="profile-brand-panel">
        <div class="profile-brand-copy">
          <img src="@/assets/daohan-logo.png" alt="道晗漫画平台" class="profile-brand-logo">
          <div>
            <p>道晗漫画平台</p>
            <h2>个人中心</h2>
            <span>管理阅读记录、账号资料与会员权益</span>
          </div>
        </div>
        <button class="brand-action" @click="goToVip">开通VIP</button>
      </section>

      <div class="feature-tabs feature-tabs-bar">
        <div class="tab" :class="{ active: activeTab === 'history' }" @click="activeTab = 'history'">
          阅读历史 ({{ historyTotal || 0 }})
        </div>
        <div class="tab" :class="{ active: activeTab === 'comments' }" @click="activeTab = 'comments'">
          我的评论
        </div>
        <div class="tab" :class="{ active: activeTab === 'settings' }" @click="activeTab = 'settings'">
          账户设置
        </div>
        <div class="tab" :class="{ active: activeTab === 'realname' }" @click="activeTab = 'realname'">
          实名认证
          <span class="realname-tab-badge" v-if="realnameStatus.verified">已认证</span>
          <span class="realname-tab-badge warn" v-else>未认证</span>
        </div>
        <div class="tab" :class="{ active: activeTab === 'favorites' }" @click="switchTab('favorites')">
          我的收藏
        </div>
        <div class="tab" :class="{ active: activeTab === 'orders' }" @click="switchTab('orders')">
          购买记录
        </div>
        <div class="tab" :class="{ active: activeTab === 'messages' }" @click="switchTab('messages')">
          消息中心
          <span class="msg-badge" v-if="unreadCount > 0">{{ unreadCount }}</span>
        </div>
      </div>

      <div class="account-layout">
        <aside class="account-sidebar">
          <div class="user-header">
            <div class="user-header-backdrop"></div>
            <div class="user-header-content">
              <div class="user-avatar" @click.stop="chooseAvatar" title="点击更换头像">
                <img :src="userInfo.avatar" :alt="userInfo.nickname">
                <div class="avatar-edit-hint">更换</div>
                <div class="user-level" v-if="userInfo.is_vip">
                  <span class="level-icon">VIP</span>
                </div>
              </div>
              <input
                ref="avatarInput"
                type="file"
                accept="image/jpeg,image/png,image/gif,image/webp"
                style="display: none"
                @change="handleAvatarChange"
              >
              <div class="user-info">
                <div class="user-basic">
                  <h1 class="nickname">{{ userInfo.nickname }}</h1>
                  <div class="user-id">ID: {{ userInfo.id }}</div>
                  <div class="user-join-time">注册于 {{ formatDate(userInfo.jointime) }}</div>
                </div>
                <div class="user-bio" v-if="userInfo.bio">“ {{ userInfo.bio }} ”</div>
                <div class="user-bio" v-else>“ 这个人很懒，还没有填写个人简介 ”</div>
              </div>
            </div>
          </div>

          <div class="user-stats">
            <div class="stat-item">
              <div class="stat-value">{{ userInfo.level || 1 }}</div>
              <div class="stat-label">等级</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">{{ userInfo.score || 0 }}</div>
              <div class="stat-label">积分</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">¥{{ userInfo.money || '0.00' }}</div>
              <div class="stat-label">余额</div>
            </div>
            <div class="stat-item vip-stat" v-if="userInfo.is_vip">
              <div class="stat-value">{{ userInfo.vip_info?.package_name || 'VIP会员' }}</div>
              <div class="stat-label">会员状态</div>
            </div>
            <div class="stat-item" v-else>
              <div class="stat-value">普通用户</div>
              <div class="stat-label">会员状态</div>
            </div>
          </div>
        </aside>

        <section class="feature-section">
        <!-- 阅读历史 -->
        <div class="tab-content" v-if="activeTab === 'history'">
          <div class="loading-state" v-if="isLoadingHistory">
            <div class="spinner"></div>
            <p>加载中...</p>
          </div>
          <div class="empty-content" v-else-if="!historyList.length">
            <div class="empty-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M2 12h5"></path>
                <path d="M9 12h5"></path>
                <path d="M16 12h6"></path>
                <path d="M3 7h7"></path>
                <path d="M13 7h8"></path>
                <path d="M5 17h6"></path>
                <path d="M14 17h5"></path>
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
              </svg>
            </div>
            <p>暂无阅读历史记录</p>
            <button class="primary-btn" @click="goToHome">去看漫画</button>
          </div>
          <div v-else>
            <div class="history-actions">
              <button class="clear-all-btn" @click="deleteAllHistory" v-if="historyList.length > 1">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 6h18"></path>
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                </svg>
                清空历史
              </button>
            </div>
            <div class="history-grid">
              <div class="history-card" v-for="(item, index) in historyList" :key="index">
                <div class="history-card-cover" @click="continueReading(item)">
                  <img :src="getFullImageUrl(item.cover)" :alt="item.title">
                  <div class="history-card-mask">
                    <div class="continue-btn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>
                      继续阅读
                    </div>
                  </div>
                </div>
                <div class="history-card-info">
                  <div class="history-card-main">
                    <h3 class="history-title" @click="continueReading(item)">{{ item.title }}</h3>
                    <div class="history-chapter">{{ item.chapter }}</div>
                  </div>
                  <div class="history-card-footer">
                    <span class="history-time">{{ formatDate(item.time) }}</span>
                    <button class="history-delete" @click="deleteHistory(item.id)" title="删除记录">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 6h18"></path>
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 我的评论 -->
        <div class="tab-content" v-if="activeTab === 'comments'">
          <div class="loading-state" v-if="isLoadingComments">
            <div class="spinner"></div>
            <p>加载中...</p>
          </div>
          <div class="empty-content" v-else-if="!commentsList.length">
            <div class="empty-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <p>暂无评论记录</p>
            <button class="primary-btn" @click="goToHome">去发表评论</button>
          </div>
          <div class="comments-list" v-else>
            <div class="comment-item" v-for="(comment, index) in commentsList" :key="index">
              <div class="comment-cover" v-if="comment.comicCover" @click="goToComic(comment.comicId)">
                <img :src="getFullImageUrl(comment.comicCover)" :alt="comment.comicTitle">
              </div>
              <div class="comment-content-wrapper">
                <div class="comment-header">
                  <div class="comic-info">
                    <h3 class="comic-title" @click="goToComic(comment.comicId)">{{ comment.comicTitle }}</h3>
                    <span class="comment-time">{{ formatDate(comment.createtime) }}</span>
                  </div>
                  <button class="delete-btn" @click="deleteComment(comment.comicId, comment.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 6h18"></path>
                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                    </svg>
                  </button>
                </div>
                <div class="comment-content">{{ comment.content }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 账户设置 -->
        <div class="tab-content" v-if="activeTab === 'settings'">
          <div class="settings-grid">
          <div class="settings-form">
            <div class="form-title">基本信息</div>
            <div class="form-group">
              <label>昵称</label>
              <input type="text" v-model="userForm.nickname" placeholder="请输入昵称">
            </div>
            <div class="form-group">
              <label>性别</label>
              <div class="radio-group">
                <label class="radio">
                  <input type="radio" name="gender" value="1" v-model="userForm.gender">
                  <span>男</span>
                </label>
                <label class="radio">
                  <input type="radio" name="gender" value="2" v-model="userForm.gender">
                  <span>女</span>
                </label>
                <label class="radio">
                  <input type="radio" name="gender" value="0" v-model="userForm.gender">
                  <span>保密</span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <label>生日</label>
              <input type="date" v-model="userForm.birthday">
            </div>
            <div class="form-group">
              <label>个人简介</label>
              <textarea v-model="userForm.bio" placeholder="请输入个人简介" rows="4"></textarea>
            </div>
            <div class="form-actions">
              <button class="primary-btn" @click="saveUserInfo">保存修改</button>
            </div>
          </div>

          <div class="settings-form">
            <div class="form-title">安全设置</div>
            <div class="form-group">
              <label>修改密码</label>
              <input type="password" v-model="passwordForm.oldPassword" placeholder="当前密码">
            </div>
            <div class="form-group">
              <input type="password" v-model="passwordForm.newPassword" placeholder="新密码">
            </div>
            <div class="form-group">
              <input type="password" v-model="passwordForm.confirmPassword" placeholder="确认新密码">
            </div>
            <div class="form-actions">
              <button class="primary-btn" @click="changePassword">修改密码</button>
            </div>
          </div>
          </div>
        </div>

        <!-- 实名认证（独立页） -->
        <div class="tab-content" v-if="activeTab === 'realname'">
          <div class="settings-grid">
          <div class="settings-form realname-page-card">
            <div class="form-title">实名认证</div>
            <template v-if="realnameStatus.verified">
              <div class="form-group">
                <label>认证状态</label>
                <div class="realname-verified">
                  <span class="realname-badge">已实名</span>
                  <span class="realname-name">{{ realnameStatus.masked_name }}</span>
                </div>
              </div>
              <div class="form-group">
                <label>出生日期</label>
                <div>{{ realnameStatus.birthday }}</div>
              </div>
              <div class="form-group" v-if="realnameStatus.is_minor">
                <label>用户类型</label>
                <div class="realname-minor-tip">未成年账号：已自动开启青少年模式，消费受限额管理，无法自行关闭</div>
              </div>
              <div class="form-group" v-else>
                <label>用户类型</label>
                <div>成年账号</div>
              </div>
              <div class="form-group">
                <label>认证时间</label>
                <div>{{ realnameStatus.verify_time }}</div>
              </div>
            </template>
            <template v-else>
              <div class="form-group">
                <label>真实姓名</label>
                <input type="text" v-model="realnameForm.name" placeholder="请输入真实姓名" maxlength="20">
              </div>
              <div class="form-group">
                <label>身份证号</label>
                <input type="text" v-model="realnameForm.idcard" placeholder="18位身份证号" maxlength="18">
              </div>
              <div class="form-actions">
                <button class="primary-btn" :disabled="realnameLoading" @click="submitRealname">
                  {{ realnameLoading ? '认证中…' : '提交认证' }}
                </button>
              </div>
              <p class="realname-error" v-if="realnameError">{{ realnameError }}</p>
            </template>
          </div>

          <div class="settings-form realname-info-card">
            <div class="form-title">实名认证须知</div>
            <ul class="realname-rules">
              <li>依据《未成年人网络保护条例》与网络实名制要求，发布评论、讨论前需完成实名认证。</li>
              <li>实名信息仅用于后台核验与未成年人保护，采用加密存储，前台仍展示昵称，不对外公开。</li>
              <li>未满 18 周岁的用户认证后将自动开启青少年模式，且无法自行关闭。</li>
              <li>未成年人消费实行限额管理：未满 8 周岁禁止消费；8-15 周岁单次不超过 50 元、每月不超过 200 元；16-17 周岁单次不超过 100 元、每月不超过 400 元。</li>
              <li>每个身份证号仅可绑定一个账号。</li>
            </ul>
          </div>
          </div>
        </div>

        <!-- 我的收藏 -->
        <div class="tab-content" v-if="activeTab === 'favorites'">
          <div class="loading-state" v-if="isLoadingFavorites">
            <div class="spinner"></div>
            <p>加载中...</p>
          </div>
          <div class="empty-content" v-else-if="!favoritesList.length">
            <p>还没有收藏任何漫画</p>
            <button class="primary-btn" @click="goToHome">去收藏漫画</button>
          </div>
          <div class="favorites-grid" v-else>
            <div class="favorite-card" v-for="item in favoritesList" :key="item.id">
              <div class="favorite-cover" @click="goToComic(item.id)">
                <img :src="getFullImageUrl(item.cover)" :alt="item.title">
              </div>
              <div class="favorite-body">
                <h3 class="favorite-title" @click="goToComic(item.id)">{{ item.title }}</h3>
                <p class="favorite-author">{{ item.author || '未知作者' }}</p>
                <p class="favorite-time">{{ formatDate(item.favorite_time || item.createtime) }} 收藏</p>
                <button class="favorite-remove" @click="removeFavorite(item.id)">取消收藏</button>
              </div>
            </div>
          </div>
        </div>

        <!-- 购买记录 -->
        <div class="tab-content" v-if="activeTab === 'orders'">
          <div class="loading-state" v-if="isLoadingOrders">
            <div class="spinner"></div>
            <p>加载中...</p>
          </div>
          <div v-else>
            <div class="orders-section">
              <h3 class="orders-title">VIP 开通记录</h3>
              <div class="empty-content" v-if="!ordersVip.length">
                <p>暂无VIP开通记录</p>
              </div>
              <div class="orders-list" v-else>
                <div class="order-item" v-for="item in ordersVip" :key="'vip-' + item.id">
                  <div>
                    <strong>{{ item.package_name || 'VIP会员' }}</strong>
                    <span>{{ formatVipDate(item.start_time) }} ~ {{ formatVipDate(item.end_time) }}</span>
                  </div>
                  <span :class="item.status === 'normal' ? 'order-ok' : 'order-expired'">
                    {{ item.status === 'normal' ? '生效中' : '已过期' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="orders-section">
              <h3 class="orders-title">漫画购买记录</h3>
              <div class="empty-content" v-if="!ordersComics.length">
                <p>暂无漫画购买记录</p>
              </div>
              <div class="orders-list" v-else>
                <div class="order-item" v-for="item in ordersComics" :key="'comic-' + item.id">
                  <div>
                    <strong>{{ item.comic_title || ('漫画#' + item.comic_id) }}</strong>
                    <span>{{ formatDate(item.createtime) }} 购买</span>
                  </div>
                  <span class="order-ok">¥{{ item.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 消息中心 -->
        <div class="tab-content" v-if="activeTab === 'messages'">
          <div class="messages-actions">
            <button class="primary-btn" @click="markAllMessagesRead" :disabled="!messagesList.length">全部标记已读</button>
          </div>
          <div class="loading-state" v-if="isLoadingMessages">
            <div class="spinner"></div>
            <p>加载中...</p>
          </div>
          <div class="empty-content" v-else-if="!messagesList.length">
            <p>暂无消息</p>
          </div>
          <div class="messages-list" v-else>
            <div
              class="message-item"
              :class="{ unread: !item.is_read }"
              v-for="item in messagesList"
              :key="item.id"
              @click="markMessageRead(item)"
            >
              <div class="message-head">
                <strong>{{ item.title }}</strong>
                <span>{{ formatDate(item.createtime) }}</span>
              </div>
              <p>{{ item.content }}</p>
              <span v-if="!item.is_read" class="message-dot"></span>
            </div>
          </div>
        </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/index'
import request from '../api/request'
import { useRouter } from 'vue-router'
import { initYouthStore } from '../utils/youthContent'

export default {
  name: 'UserCenter',
  setup() {
    const router = useRouter()
    return { router }
  },
  data() {
    return {
      userInfo: {},
      activeTab: 'history',
      historyList: [],
      historyTotal: 0,
      isLoadingHistory: false,
      commentsList: [],
      isLoadingComments: false,
      userForm: {
        nickname: '',
        gender: 0,
        birthday: '',
        bio: '',
        avatar: ''
      },
      isUploadingAvatar: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      baseUrl: request.baseUrl,
      // 我的收藏
      favoritesList: [],
      isLoadingFavorites: false,
      // 购买记录
      ordersVip: [],
      ordersComics: [],
      isLoadingOrders: false,
      // 消息中心
      messagesList: [],
      isLoadingMessages: false,
      unreadCount: 0,
      // 实名认证
      realnameStatus: {
        verified: false,
        is_minor: false,
        masked_name: ''
      },
      realnameForm: {
        name: '',
        idcard: ''
      },
      realnameLoading: false,
      realnameError: ''
    }
  },
  created() {
    initYouthStore()
    this.getUserInfo()
    this.getReadingHistory()
    this.loadFavorites()
    this.loadOrders()
    this.loadMessages()
    this.loadRealnameStatus()

    // 检查URL中的tab参数
    const urlParams = new URLSearchParams(window.location.search)
    const tab = urlParams.get('tab')
    if (tab) {
      this.activeTab = tab
    }

    // 加载评论数据
    this.loadUserComments()
  },
  methods: {
    async loadRealnameStatus() {
      try {
        const res = await api.getRealnameStatus()
        if (res && res.code === 1 && res.data) {
          this.realnameStatus = res.data
        }
      } catch (e) {
        // 未登录或接口异常时保持未认证状态
      }
    },
    async submitRealname() {
      this.realnameError = ''
      const name = (this.realnameForm.name || '').trim()
      const idcard = (this.realnameForm.idcard || '').trim()
      if (!name) {
        this.realnameError = '请输入真实姓名'
        return
      }
      if (!/^\d{17}[\dXx]$/.test(idcard)) {
        this.realnameError = '请输入18位有效身份证号'
        return
      }
      this.realnameLoading = true
      try {
        const res = await api.submitRealname({ name, idcard })
        if (res && res.code === 1) {
          await this.loadRealnameStatus()
          this.$message.success(res.msg || '实名认证通过')
          // 未成年认证通过后强制开启青少年模式，刷新本地状态与服务端对账
          initYouthStore()
        } else {
          this.realnameError = (res && res.msg) || '认证失败，请稍后重试'
        }
      } catch (e) {
        this.realnameError = (e && e.message) || '认证失败，请稍后重试'
      } finally {
        this.realnameLoading = false
      }
    },
    async getUserInfo() {
      try {
        // 从localStorage获取token
        const token = localStorage.getItem('token')
        if (!token) {
          console.log('未找到token，跳转到登录页');
          this.router.push('/login')
          return
        }
        
        console.log('开始获取用户信息，token:', token.substring(0, 8) + '...');
        const res = await api.getUserInfo()
        console.log('获取用户信息结果:', res);
        
        if (res && res.code === 1 && res.data) {
          this.userInfo = res.data
          // 将用户数据填充到表单
          this.userForm.nickname = this.userInfo.nickname || ''
          this.userForm.gender = this.userInfo.gender || 0
          this.userForm.birthday = this.userInfo.birthday || ''
          this.userForm.bio = this.userInfo.bio || ''
          this.userForm.avatar = this.userInfo.avatar || ''
        } else {
          // 获取用户信息失败
          console.error('获取用户信息返回格式错误:', res);
          // 尝试使用本地缓存
          const cachedUserInfo = localStorage.getItem('userInfo');
          if (cachedUserInfo) {
            console.log('API返回无效，使用缓存用户信息');
            this.userInfo = JSON.parse(cachedUserInfo);
          } else {
            alert('获取用户信息失败，请重新登录');
            this.router.push('/login')
          }
        }
      } catch (error) {
        console.error('获取用户信息异常:', error);
        
        // 尝试使用本地缓存
        const cachedUserInfo = localStorage.getItem('userInfo');
        if (cachedUserInfo) {
          console.log('使用缓存的用户信息');
          this.userInfo = JSON.parse(cachedUserInfo);
        } else {
          // 处理登录过期或其他错误
          alert('获取用户信息失败：' + (error?.message || '未知错误'));
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          this.router.push('/login');
        }
      }
    },
    formatDate(timestamp) {
      if (!timestamp) return '未知'
      try {
        const date = new Date(timestamp * 1000)
        if (isNaN(date.getTime())) return '格式错误'
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
      } catch (e) {
        console.error('日期格式化错误:', timestamp, e)
        return '格式错误'
      }
    },
    formatVipDate(dateString) {
      if (!dateString) return '未知'
      try {
        // 处理字符串格式的日期，如 "2025-05-21 15:34:41"
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return '格式错误'
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
      } catch (e) {
        console.error('VIP日期格式化错误:', dateString, e)
        return '格式错误'
      }
    },
    goToHome() {
      this.router.push('/')
    },
    goToVip() {
      this.router.push('/vip')
    },
    async deleteHistory(id) {
      try {
        if (!confirm('确定要删除这条阅读记录吗？')) return
        
        this.isLoadingHistory = true
        
        // 调用API删除历史记录
        const response = await api.deleteReadingHistory(id)
        console.log('删除历史记录结果:', response)
        
        if (response && response.code === 1) {
          // 前端先删除列表项，视觉上立即响应
          this.historyList = this.historyList.filter(item => item.id !== id)
          
          // 删除成功提示
          alert('删除成功')
        } else {
          // 删除失败
          alert(response?.msg || '删除失败')
        }
      } catch (error) {
        console.error('删除历史记录异常:', error)
        alert('删除失败: ' + (error?.message || '未知错误'))
      } finally {
        this.isLoadingHistory = false
      }
    },
    chooseAvatar() {
      if (this.$refs.avatarInput) {
        this.$refs.avatarInput.click()
      }
    },
    async handleAvatarChange(event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (!file) return
      if (!/^image\//.test(file.type)) {
        this.$message.error('请选择图片文件')
        return
      }
      if (file.size > 4 * 1024 * 1024) {
        this.$message.error('图片不能超过4MB')
        return
      }
      this.isUploadingAvatar = true
      try {
        const res = await api.uploadFile(file)
        if (res && res.code === 1 && res.data) {
          const url = res.data.fullurl || res.data.url || ''
          this.userForm.avatar = url
          // 直接保存头像，无需再点保存
          await this.saveAvatar(url)
        } else {
          this.$message.error((res && res.msg) || '头像上传失败')
        }
      } catch (error) {
        this.$message.error('头像上传失败：' + ((error && error.message) || '未知错误'))
      } finally {
        this.isUploadingAvatar = false
      }
    },
    async saveAvatar(url) {
      try {
        const res = await api.updateProfile({ avatar: url })
        if (res && res.code === 1) {
          this.$message.success('头像已更新')
          await this.getUserInfo()
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          window.dispatchEvent(new Event('user-info-updated'))
        } else {
          this.$message.error((res && res.msg) || '头像保存失败')
        }
      } catch (error) {
        this.$message.error('头像保存失败：' + ((error && error.message) || '未知错误'))
      }
    },
    async saveUserInfo() {
      if (!this.userForm.nickname || !String(this.userForm.nickname).trim()) {
        this.$message.error('昵称不能为空')
        return
      }
      try {
        const payload = {
          nickname: String(this.userForm.nickname).trim(),
          gender: Number(this.userForm.gender),
          birthday: this.userForm.birthday || '',
          bio: this.userForm.bio || ''
        }
        const res = await api.updateProfile(payload)
        if (res && res.code === 1) {
          this.$message.success('保存成功')
          // 刷新用户信息与本地缓存，并通知全局（侧边栏头像等）同步更新
          await this.getUserInfo()
          localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
          window.dispatchEvent(new Event('user-info-updated'))
        } else {
          this.$message.error((res && res.msg) || '保存失败')
        }
      } catch (error) {
        this.$message.error('保存失败：' + ((error && error.message) || '未知错误'))
      }
    },
    async changePassword() {
      // 表单验证
      if (!this.passwordForm.oldPassword) {
        this.$message.error('请输入当前密码')
        return
      }
      if (!this.passwordForm.newPassword) {
        this.$message.error('请输入新密码')
        return
      }
      if (this.passwordForm.newPassword.length < 6 || this.passwordForm.newPassword.length > 30) {
        this.$message.error('新密码需为6-30位')
        return
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message.error('两次密码输入不一致')
        return
      }
      
      try {
        const res = await api.changePassword({
          oldpassword: this.passwordForm.oldPassword,
          newpassword: this.passwordForm.newPassword
        })
        if (res && res.code === 1) {
          this.passwordForm = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
          }
          this.$message.success('密码修改成功，请重新登录')
          // 后端已注销当前Token，清除凭证并跳转登录页
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          setTimeout(() => {
            this.router.push('/login')
          }, 1200)
        } else {
          this.$message.error((res && res.msg) || '密码修改失败')
        }
      } catch (error) {
        this.$message.error((error && error.message) || '密码修改失败')
      }
    },
    async getReadingHistory() {
      try {
        this.isLoadingHistory = true
        const res = await api.getReadingHistory()
        console.log('获取阅读历史结果:', res)
        
        if (res && res.code === 1 && res.data) {
          // 转换API返回的数据格式
          this.historyList = res.data.list.map(item => ({
            id: item.id,
            comic_id: item.comic_id,
            chapter_id: item.chapter_id,
            title: item.comic_title,
            chapter: item.chapter_title,
            time: item.updatetime,
            cover: item.cover // 直接使用API返回的封面图
          }))
          this.historyTotal = res.data.total
        } else {
          console.error('获取阅读历史返回格式错误:', res)
          this.$message.warning((res && res.msg) || '阅读历史加载失败，请稍后重试')
        }
      } catch (error) {
        console.error('获取阅读历史异常:', error)
        this.$message.warning('阅读历史加载失败：' + ((error && error.message) || '未知错误'))
      } finally {
        this.isLoadingHistory = false
      }
    },
    continueReading(item) {
      console.log('继续阅读:', item)
      // 跳转到漫画阅读页面
      this.router.push(`/comic/${item.comic_id}/chapter/${item.chapter_id}`)
    },
    getFullImageUrl(cover) {
      if (cover && /^https?:\/\//i.test(cover)) return cover
      if (cover && cover.startsWith('//')) return window.location.protocol + cover
      if (cover && cover.startsWith('/')) return request.baseUrl + cover
      if (cover) return `${request.baseUrl}/${cover}`
      return 'https://via.placeholder.com/80x100'
    },
    // 加载用户评论（服务端）
    async loadUserComments() {
      this.isLoadingComments = true
      try {
        const res = await api.getMyComments()
        console.log('获取我的评论结果:', res)
        
        if (res && res.code === 1 && res.data) {
          this.commentsList = (res.data.list || []).map(item => ({
            id: item.id,
            comicId: item.comic_id,
            comicTitle: item.comic_title || '未知漫画',
            comicCover: item.comic_cover || null,
            content: item.content,
            createtime: item.createtime
          }))
        } else {
          this.commentsList = []
          this.$message.warning((res && res.msg) || '评论加载失败，请稍后重试')
        }
      } catch (error) {
        console.error('加载我的评论失败:', error)
        this.$message.warning('评论加载失败：' + ((error && error.message) || '未知错误'))
      } finally {
        this.isLoadingComments = false
      }
    },
    
    // 删除评论（服务端）
    async deleteComment(comicId, commentId) {
      if (!confirm('确定要删除这条评论吗？')) return
      try {
        const res = await api.deleteComicComment(commentId)
        if (res && res.code === 1) {
          // 更新当前列表
          this.commentsList = this.commentsList.filter(comment => comment.id !== commentId)
          this.$message.success('评论已删除')
        } else {
          this.$message.error((res && res.msg) || '删除失败')
        }
      } catch (error) {
        this.$message.error((error && error.message) || '删除失败')
      }
    },
    
    // 跳转到漫画详情页
    goToComic(comicId) {
      this.router.push(`/comic/${comicId}`)
    },
    async deleteAllHistory() {
      try {
        if (!confirm('确定要清空所有阅读历史吗？此操作不可恢复！')) return
        
        this.isLoadingHistory = true
        
        // 调用API删除所有历史记录(不传ID)
        const response = await api.deleteReadingHistory()
        console.log('清空历史记录结果:', response)
        
        if (response && response.code === 1) {
          // 清空前端列表
          this.historyList = []
          this.historyTotal = 0
          
          // 删除成功提示
          alert('已清空所有阅读历史')
        } else {
          // 删除失败
          alert(response?.msg || '清空失败')
        }
      } catch (error) {
        console.error('清空历史记录异常:', error)
        alert('清空失败: ' + (error?.message || '未知错误'))
      } finally {
        this.isLoadingHistory = false
      }
    },
    switchTab(name) {
      this.activeTab = name
      if (name === 'favorites') this.loadFavorites()
      if (name === 'orders') this.loadOrders()
      if (name === 'messages') this.loadMessages()
    },
    // ===== 我的收藏 =====
    async loadFavorites() {
      this.isLoadingFavorites = true
      try {
        const res = await api.getMyFavorites()
        if (res && res.code === 1 && res.data) {
          this.favoritesList = res.data.list || []
        } else {
          this.favoritesList = []
        }
      } catch (error) {
        console.error('加载收藏失败:', error)
        this.$message.warning('收藏加载失败，请稍后重试')
      } finally {
        this.isLoadingFavorites = false
      }
    },
    async removeFavorite(id) {
      if (!confirm('确定取消收藏这部漫画吗？')) return
      try {
        const res = await api.unfavoriteComic(id)
        if (res && res.code === 1) {
          this.favoritesList = this.favoritesList.filter(item => item.id !== id)
          this.$message.success('已取消收藏')
        } else {
          this.$message.error((res && res.msg) || '操作失败')
        }
      } catch (error) {
        this.$message.error((error && error.message) || '操作失败')
      }
    },
    // ===== 购买记录 =====
    async loadOrders() {
      this.isLoadingOrders = true
      try {
        const res = await api.getPurchaseHistory()
        if (res && res.code === 1 && res.data) {
          this.ordersVip = res.data.vip || []
          this.ordersComics = res.data.comics || []
        }
      } catch (error) {
        console.error('加载购买记录失败:', error)
      } finally {
        this.isLoadingOrders = false
      }
    },
    // ===== 消息中心 =====
    async loadMessages() {
      this.isLoadingMessages = true
      try {
        const res = await api.getMessages()
        if (res && res.code === 1 && res.data) {
          this.messagesList = res.data.list || []
          this.unreadCount = res.data.unread || 0
        }
      } catch (error) {
        console.error('加载消息失败:', error)
      } finally {
        this.isLoadingMessages = false
      }
    },
    async markMessageRead(item) {
      if (item.is_read) return
      try {
        const res = await api.markMessagesRead(item.id)
        if (res && res.code === 1) {
          item.is_read = 1
          this.unreadCount = Math.max(0, this.unreadCount - 1)
        }
      } catch (error) {
        console.error('标记已读失败:', error)
      }
    },
    async markAllMessagesRead() {
      try {
        const res = await api.markMessagesRead()
        if (res && res.code === 1) {
          this.messagesList.forEach(item => { item.is_read = 1 })
          this.unreadCount = 0
          this.$message.success('已全部标记为已读')
        }
      } catch (error) {
        this.$message.error((error && error.message) || '操作失败')
      }
    }
  }
}
</script>

<style scoped>
.profile-brand-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 24px;
  padding: 22px;
  border-radius: 26px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(232, 250, 250, 0.92)),
    radial-gradient(circle at 92% 20%, rgba(49, 210, 210, 0.18), transparent 24%);
  border: 1px solid rgba(29, 42, 69, 0.08);
  box-shadow: 0 24px 60px rgba(35, 53, 95, 0.12);
}

.profile-brand-copy {
  display: flex;
  align-items: center;
  gap: 18px;
}

.profile-brand-logo {
  width: 118px;
  height: 86px;
  object-fit: contain;
  border-radius: 18px;
  background: #fff;
  padding: 8px;
  box-shadow: 0 16px 38px rgba(23, 34, 63, 0.12);
}

.profile-brand-copy p {
  margin: 0 0 6px;
  color: #12aeb8;
  font-size: 14px;
  font-weight: 900;
}

.profile-brand-copy h2 {
  margin: 0;
  color: #17223f;
  font-size: 30px;
  letter-spacing: 0;
}

.profile-brand-copy span {
  display: block;
  margin-top: 8px;
  color: #63708d;
  font-size: 14px;
}

.brand-action {
  border: 0;
  border-radius: 999px;
  min-height: 46px;
  padding: 0 24px;
  color: #fff;
  font-weight: 900;
  cursor: pointer;
  background: linear-gradient(135deg, #22d3d7, #17223f);
  box-shadow: 0 14px 30px rgba(26, 190, 197, 0.28);
}

.youth-payment-notice {
  margin: 0 0 16px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 204, 102, 0.46);
  border-radius: 8px;
  background: rgba(255, 204, 102, 0.12);
  color: #ffd98a;
  font-size: 14px;
  line-height: 1.6;
}

.plan-item.disabled {
  opacity: 0.55;
}

.plan-item.disabled .plan-btn,
.vip-btn:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.user-center {
  padding: 30px 0;
  background:
    radial-gradient(circle at 8% 0%, rgba(57, 214, 214, 0.16), transparent 28%),
    radial-gradient(circle at 92% 8%, rgba(37, 44, 64, 0.12), transparent 34%),
    linear-gradient(180deg, #f7fbff 0%, #eef6ff 100%);
  min-height: calc(100vh - 70px);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 用户信息头部 */
.user-header {
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 25px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.user-header-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  background: linear-gradient(135deg, #8e2de2, #4a00e0);
  z-index: 0;
}

.user-header-content {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  padding: 30px;
  padding-top: 70px;
}

.user-avatar {
  position: relative;
  flex: 0 0 120px;
  margin-top: -50px;
}

.user-avatar img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.user-level {
  position: absolute;
  bottom: 5px;
  right: 0;
  background: linear-gradient(135deg, #ff9a44, #fc6076);
  color: #fff;
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 10px rgba(255, 107, 107, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.user-info {
  flex: 1;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
}

.user-basic {
  margin-bottom: 25px;
}

.nickname {
  font-size: 24px;
  margin-bottom: 5px;
  font-weight: 700;
  color: #fff;
  display: flex;
  align-items: center;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.user-id {
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
  opacity: 0.9;
}

.user-join-time {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}

.user-bio {
  margin-top: 25px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  background-color: #f9f9f9;
  padding: 12px 15px;
  border-radius: 8px;
  position: relative;
  border-left: 3px solid #ff6b6b;
}

.user-stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  background: #f9f9f9;
  border-radius: 10px;
  padding: 15px;
}

.stat-item {
  flex: 1;
  min-width: 80px;
  text-align: center;
  padding: 0 10px;
  position: relative;
}

.stat-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 70%;
  width: 1px;
  background-color: #e0e0e0;
}

.stat-item .stat-value {
  font-weight: 700;
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.stat-item .stat-label {
  font-size: 12px;
  color: #999;
}

.stat-item.vip-stat .stat-value {
  color: #ff6b6b;
  background: linear-gradient(135deg, #ff9a44, #fc6076);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* 功能区域 */
.feature-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.feature-tabs {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
}

.tab {
  padding: 15px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
}

.tab:hover {
  color: #ff6b6b;
}

.tab.active {
  color: #ff6b6b;
  font-weight: bold;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 2px;
  background-color: #ff6b6b;
}

.tab-content {
  padding: 20px;
}

/* 阅读历史 */
.loading-state {
  text-align: center;
  padding: 60px 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ff6b6b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-state p {
  color: #999;
}

.empty-content {
  text-align: center;
  padding: 60px 0;
}

.empty-icon {
  font-size: 50px;
  margin-bottom: 20px;
}

.empty-content p {
  color: #999;
  margin-bottom: 20px;
}

.primary-btn {
  background-color: #ff6b6b;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.primary-btn:hover {
  background-color: #ff5252;
}

.history-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.clear-all-btn {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 8px 12px;
  font-size: 13px;
  border-radius: 4px;
  transition: all 0.3s;
}

.clear-all-btn svg {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.clear-all-btn:hover {
  background-color: #ff6b6b;
  color: white;
}

.history-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.history-card {
  flex: 1 0 calc(33.33% - 10px);
  min-width: 250px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.history-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.history-card-cover {
  position: relative;
  height: 160px;
  overflow: hidden;
}

.history-card-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.history-card:hover .history-card-cover img {
  transform: scale(1.05);
}

.history-card-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.history-card:hover .history-card-mask {
  opacity: 1;
}

.continue-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 107, 107, 0.9);
  color: white;
  border-radius: 30px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
}

.continue-btn svg {
  margin-right: 5px;
}

.continue-btn:hover {
  background: rgba(255, 107, 107, 1);
  transform: scale(1.05);
}

.history-card-info {
  padding: 15px;
}

.history-card-main {
  margin-bottom: 10px;
}

.history-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.2s;
}

.history-title:hover {
  color: #ff6b6b;
}

.history-chapter {
  font-size: 14px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.history-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.history-time {
  font-size: 12px;
  color: #999;
}

.history-delete {
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.history-delete:hover {
  color: #ff6b6b;
  background-color: rgba(255,107,107,0.1);
}

@media (max-width: 768px) {
  .user-header {
    padding: 0;
  }
  
  .user-header-content {
    flex-direction: column;
    padding: 20px;
    padding-top: 80px;
    align-items: center;
    text-align: center;
  }
  
  .user-avatar {
    margin-top: -40px;
    margin-bottom: 15px;
  }
  
  .user-info {
    margin-left: 0;
    width: 100%;
  }
  
  .user-basic {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .user-stats {
    flex-wrap: wrap;
  }
  
  .stat-item {
    flex: 1 0 40%;
    margin-bottom: 10px;
  }
  
  .stat-item:nth-child(2n)::after {
    display: none;
  }
  
  .feature-tabs {
    flex-wrap: wrap;
  }
  
  .benefit-list {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .plan-list {
    flex-direction: column;
  }
  
  .history-grid {
    gap: 10px;
  }
  
  .history-card {
    flex: 1 0 calc(50% - 5px);
    min-width: auto;
  }
}

@media (max-width: 480px) {
  .history-card {
    flex: 1 0 100%;
  }
}

/* 账户设置 */
.settings-form {
  margin-bottom: 30px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 20px;
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
}

.form-group input, 
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: all 0.3s;
}

.form-group input:focus, 
.form-group textarea:focus {
  border-color: #ff6b6b;
  outline: none;
}

.avatar-uploader {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.avatar-uploader img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 20px;
}

.avatar-hint {
  display: block;
  margin-top: 8px;
  color: #12aeb8;
  font-size: 12px;
}

.upload-btn {
  padding: 8px 15px;
  background-color: #f0f0f0;
  color: #17223f;
  font-size: 13px;
  font-weight: 800;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.upload-btn:hover {
  background-color: #12aeb8;
  border-color: #12aeb8;
  color: #ffffff;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.radio {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.radio input {
  width: auto;
  margin-right: 8px;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
}

/* 会员中心 */
.vip-card {
  background: linear-gradient(135deg, #8e2de2, #4a00e0);
  color: #fff;
  border-radius: 8px;
  padding: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(142, 45, 226, 0.3);
}

.vip-card::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%);
  animation: shine 8s linear infinite;
}

@keyframes shine {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.vip-card.is-vip {
  background: linear-gradient(135deg, #ff9a44, #fc6076);
  box-shadow: 0 10px 30px rgba(252, 96, 118, 0.3);
}

.vip-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #ffd700;
  color: #8e2de2;
  padding: 3px 8px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 12px;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.5);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.vip-status h3 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #fff;
}

.vip-status p {
  font-size: 14px;
  opacity: 0.8;
  color: #fff;
}

.vip-btn {
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 10px 25px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.vip-btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.vip-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.btn-text {
  margin-right: 8px;
}

.btn-icon {
  font-size: 16px;
  transition: transform 0.3s;
}

.vip-btn:hover .btn-icon {
  transform: translateX(5px);
}

.vip-benefits {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
}

.vip-benefits h3 {
  font-size: 18px;
  margin-bottom: 20px;
}

.benefit-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.benefit-item {
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.benefit-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.benefit-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}

.benefit-desc {
  font-size: 12px;
  color: #999;
  line-height: 1.4;
}

.vip-plans {
  margin-bottom: 30px;
}

.vip-plans h3 {
  font-size: 18px;
  margin-bottom: 20px;
}

.plan-list {
  display: flex;
  gap: 20px;
  margin-bottom: 0;
}

.plan-item {
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.plan-item.active {
  border-color: #ff6b6b;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
}

.plan-duration {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.plan-price {
  font-size: 28px;
  font-weight: bold;
  color: #ff6b6b;
  margin-bottom: 5px;
}

.plan-days {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}

.plan-desc {
  font-size: 12px;
  color: #999;
  line-height: 1.4;
}

.plan-btn {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.plan-item.active .plan-btn {
  background-color: #ff6b6b;
  color: #fff;
  border-color: #ff6b6b;
}

.checkout-action {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.checkout-action .primary-btn {
  padding: 12px 40px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(255, 107, 107, 0.3);
  transition: all 0.3s;
}

.checkout-action .primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(255, 107, 107, 0.4);
  background-color: #ff5252;
}

.checkout-action .primary-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.7;
}

/* 支付弹窗 */
.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.payment-content {
  background-color: #fff;
  width: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.payment-header {
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.payment-body {
  padding: 20px;
  text-align: center;
}

.package-info {
  margin-bottom: 20px;
}

.package-info h4 {
  font-size: 18px;
  margin-bottom: 10px;
}

.package-info .price {
  font-size: 24px;
  color: #ff6b6b;
  font-weight: bold;
  margin-bottom: 5px;
}

.package-info .duration {
  font-size: 14px;
  color: #999;
}

.qrcode-container {
  margin: 20px auto;
}

.qrcode-container img {
  width: 180px;
  height: 180px;
  border: 1px solid #f0f0f0;
  padding: 10px;
}

.qrcode-container p {
  margin-top: 15px;
  font-size: 14px;
  color: #666;
}

/* 我的评论样式 */
.comments-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.comment-item {
  display: flex;
  background: white;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.comment-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.comment-cover {
  width: 80px;
  height: 110px;
  margin-right: 15px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(0,0,0,0.1);
}

.comment-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.comment-cover:hover img {
  transform: scale(1.05);
}

.comment-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.comment-header .comic-info {
  flex: 1;
}

.comment-header .comic-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 5px 0;
  color: #333;
  cursor: pointer;
  transition: color 0.2s;
}

.comment-header .comic-title:hover {
  color: #ff6b6b;
}

.comment-header .comment-time {
  font-size: 12px;
  color: #888;
}

.comment-header .delete-btn {
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.comment-header .delete-btn:hover {
  color: #ff6b6b;
  background-color: rgba(255,107,107,0.1);
}

.comment-content {
  font-size: 15px;
  line-height: 1.6;
  color: #555;
  padding: 0 5px;
  white-space: pre-line;
}

.user-header,
.feature-section {
  border: 1px solid rgba(29, 42, 69, 0.08);
  border-radius: 10px;
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
  background: linear-gradient(180deg, rgba(20, 24, 39, 0.95), rgba(10, 13, 24, 0.98));
}

.feature-tabs {
  background: rgba(5, 8, 16, 0.86);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.tab.active {
  color: #0f9fa7;
}

.tab.active::after {
  background: linear-gradient(135deg, #22d3d7, #17223f);
}

.vip-card {
  background:
    radial-gradient(circle at 88% 18%, rgba(255, 204, 102, 0.2), transparent 26%),
    linear-gradient(135deg, #141a2b, #070912) !important;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.vip-btn,
.primary-btn,
.checkout-action .primary-btn {
  background: linear-gradient(135deg, #22d3d7, #17223f) !important;
  border: 0;
}

@media (max-width: 720px) {
  .profile-brand-panel,
  .profile-brand-copy {
    align-items: flex-start;
    flex-direction: column;
  }

  .profile-brand-logo {
    width: 140px;
    height: 96px;
  }

  .brand-action {
    width: 100%;
  }
}
</style> 

<style scoped>
/* 深色会员仪表盘覆盖 */
.account-layout {
  display: grid;
  grid-template-columns: 330px minmax(0, 1fr);
  gap: 22px;
  align-items: start;
}

.account-sidebar {
  position: sticky;
  top: 24px;
  display: grid;
  gap: 16px;
}

.account-sidebar .user-header {
  margin-bottom: 0;
}

.account-sidebar .user-header-content {
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  padding-top: 86px;
}

.account-sidebar .user-avatar {
  margin-top: -58px;
}

.account-sidebar .user-info {
  margin-left: 0;
  width: 100%;
}

.account-sidebar .user-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 0;
}

.account-sidebar .stat-item {
  min-width: 0;
  padding: 14px 8px;
}

.account-sidebar .stat-item::after {
  display: none;
}

.account-sidebar .feature-tabs {
  display: grid;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
}

.account-sidebar .tab {
  border-radius: 8px;
  padding: 13px 14px;
}

.account-sidebar .tab.active {
  background: rgba(255, 255, 255, 0.08);
}

.account-sidebar .tab.active::after {
  display: none;
}

.profile-brand-panel {
  border-radius: 10px;
  background:
    radial-gradient(circle at 82% 12%, rgba(255, 204, 102, 0.18), transparent 28%),
    linear-gradient(135deg, rgba(23, 28, 48, 0.98), rgba(8, 11, 20, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 30px 76px rgba(0, 0, 0, 0.34);
}

.profile-brand-copy h2,
.nickname,
.stat-item .stat-value,
.form-title,
.vip-status h3,
.vip-plans h3,
.vip-benefits h3,
.plan-duration,
.history-title,
.comment-header .comic-title {
  color: #f8fbff !important;
}

.profile-brand-copy span,
.user-bio,
.user-id,
.user-join-time,
.stat-item .stat-label,
.history-chapter,
.history-time,
.comment-content,
.benefit-desc,
.plan-desc,
.plan-days {
  color: #9faaca !important;
}

.profile-brand-logo {
  border-radius: 8px;
}

.user-center {
  color: #eef3ff;
  background:
    radial-gradient(circle at 12% 0%, rgba(255, 204, 102, 0.12), transparent 30%),
    radial-gradient(circle at 90% 10%, rgba(35, 211, 238, 0.1), transparent 30%),
    linear-gradient(180deg, rgba(7, 9, 18, 0.18), rgba(7, 9, 18, 0.7));
}

.user-header-backdrop {
  background:
    radial-gradient(circle at 72% 18%, rgba(35, 211, 238, 0.2), transparent 28%),
    linear-gradient(135deg, #121827, #080b14);
}

.user-avatar img {
  border-color: rgba(255, 255, 255, 0.86);
}

.user-bio,
.user-stats,
.vip-benefits,
.settings-form,
.plan-item,
.benefit-item,
.history-card,
.comment-item {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 10px !important;
}

.tab {
  color: #9faaca;
}

.tab.active,
.tab:hover {
  color: #23d3ee;
}

.brand-action,
.vip-btn {
  color: #07101d !important;
  background: linear-gradient(135deg, #ffcc66, #23d3ee) !important;
}

/* 支付/保存/修改密码等主按钮：恢复纯色设计，去掉难看的新变色 */
.primary-btn,
.checkout-action .primary-btn,
.plan-item.active .plan-btn {
  color: #ffffff !important;
  background: #ff6b6b !important;
  box-shadow: 0 4px 10px rgba(255, 107, 107, 0.35) !important;
}

.primary-btn:hover,
.checkout-action .primary-btn:hover,
.plan-item.active .plan-btn:hover {
  color: #ffffff !important;
  background: #ff5252 !important;
}

.primary-btn:disabled,
.checkout-action .primary-btn:disabled {
  background: #9aa0ac !important;
  box-shadow: none !important;
}

.form-group input,
.form-group textarea {
  background: rgba(5, 8, 16, 0.8);
  border-color: rgba(255, 255, 255, 0.12);
  color: #eef3ff;
}

.payment-content {
  background: #111525;
  color: #eef3ff;
  border-radius: 10px;
}

@media (max-width: 1020px) {
  .account-layout {
    grid-template-columns: 1fr;
  }

  .account-sidebar {
    position: static;
  }
}
</style>

<style scoped>
/* ===== 我的收藏 / 购买记录 / 消息中心 ===== */
.msg-badge {
  display: inline-block;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 999px;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  background: #ff6b6b;
}

.favorites-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.favorite-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(180deg, rgba(22, 26, 43, 0.96), rgba(11, 14, 25, 0.98));
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.28);
}

.favorite-cover {
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  border-radius: 8px;
  background: #070912;
  cursor: pointer;
}

.favorite-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.favorite-body {
  min-width: 0;
}

.favorite-title {
  color: #f5f7ff;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.favorite-author {
  margin-top: 4px;
  color: #9faaca;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.favorite-time {
  margin-top: 4px;
  color: #6b7695;
  font-size: 12px;
}

.favorite-remove {
  margin-top: 8px;
  padding: 5px 12px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 6px;
  color: #ff8a80;
  font-size: 12px;
  cursor: pointer;
  background: transparent;
}

.orders-section {
  margin-bottom: 24px;
}

.orders-title {
  margin-bottom: 12px;
  color: #f5f7ff;
  font-size: 16px;
}

.orders-list {
  display: grid;
  gap: 10px;
}

.order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
}

.order-item strong {
  display: block;
  color: #f5f7ff;
}

.order-item span {
  margin-top: 4px;
  color: #9faaca;
  font-size: 13px;
}

.order-ok {
  color: #3ddc97 !important;
  font-weight: 800;
}

.order-expired {
  color: #ff8a80 !important;
}

.messages-actions {
  margin-bottom: 14px;
}

.messages-list {
  display: grid;
  gap: 10px;
}

.message-item {
  position: relative;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.message-item.unread {
  border-color: rgba(35, 211, 238, 0.35);
  background: rgba(35, 211, 238, 0.06);
}

.message-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.message-head strong {
  color: #f5f7ff;
}

.message-head span {
  color: #6b7695;
  font-size: 12px;
}

.message-item p {
  margin-top: 6px;
  color: #9faaca;
  font-size: 13px;
  line-height: 1.7;
}

.message-dot {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #23d3ee;
}

/* 账户设置：基本信息与安全设置并排，减少纵向高度 */
.settings-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

/* 顶部横向标签栏：把 7 个标签从侧边栏移到内容区上方，减少整页高度 */
.feature-tabs-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.feature-tabs-bar .tab {
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 14px;
  white-space: nowrap;
}

.feature-tabs-bar .tab.active {
  color: #23d3ee;
  background: rgba(255, 255, 255, 0.1);
}

.feature-tabs-bar .tab.active::after {
  display: none;
}

@media (max-width: 900px) {
  .settings-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1100px) {
  .favorites-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .favorites-grid {
    grid-template-columns: 1fr;
  }
}

/* 头像点击更换：悬停显示“更换”遮罩 */
.account-sidebar .user-avatar {
  cursor: pointer;
}

.user-avatar .avatar-edit-hint {
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;
}

.user-avatar:hover .avatar-edit-hint {
  opacity: 1;
}

/* 昵称使用 flex 布局，需单独居中 */
.account-sidebar .nickname {
  justify-content: center;
}
</style> 

<style>
/* 实名认证卡片 */
.realname-verified {
  display: flex;
  align-items: center;
  gap: 10px;
}

.realname-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 6px;
  background: linear-gradient(135deg, #0fa8bc, #0c7fb0);
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 2px;
}

.realname-name {
  font-size: 14px;
  color: #d8dee9;
}

.realname-minor-tip {
  font-size: 13px;
  color: #ffd666;
  background: rgba(250, 173, 20, 0.08);
  border: 1px solid rgba(250, 173, 20, 0.35);
  border-radius: 6px;
  padding: 8px 10px;
}

.realname-error {
  margin-top: 8px;
  font-size: 13px;
  color: #f5222d;
}

.realname-note {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}
</style>

<style>
/* 实名认证独立 Tab */
.realname-tab-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: #0d93ad;
  color: #ffffff;
  vertical-align: middle;
}

.realname-tab-badge.warn {
  background: #faad14;
}

.realname-rules {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  color: #666;
  line-height: 2;
}

.realname-info-card .form-title {
  margin-bottom: 12px;
}
</style>
